import { render } from "./_whats_new.vue?vue&type=template&id=a77f0d7e&scoped=true"
import script from "./_whats_new.vue?vue&type=script&lang=js"
export * from "./_whats_new.vue?vue&type=script&lang=js"

import "./_whats_new.vue?vue&type=style&index=0&id=a77f0d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77f0d7e"]])

export default __exports__